import { useTheme } from 'styled-components';
export function useDesignSystemTheme() {
  return useTheme();
}
export { DesignSystemThemeProvider } from './DesignSystemThemeProvider';
export { withDesignSystemTheme } from './withDesignSystemTheme';